import { UserRole, UserRoles } from '@/types/User'

export const UserRolesIdMapping = {
  0: 'applicant',
  1: 'member',
  2: 'admin',
  3: 'host',
  4: 'guest',
  5: 'super_admin',
  6: 'partner',
  7: 'read_only_admin',
  8: 'company_owner',
  9: 'property_manager',
  10: 'affiliate',
  11: 'accounting_admin',
  12: 'designer',
  13: 'property_portal',
  14: 'employee_mover',
  15: 'painter',
  16: 'manual_scraper',
  17: 'fte_housekeeper',
  18: '3p_cleaner',
  19: 'professional_housing_coordinator',
  20: 'direct_partner',
  21: 'hub_manager',
  22: 'area_general_manager',
  23: 'automated_scraper',
}

export const isUserRequiredRole = (user: { role: UserRole }) =>
  user.role === UserRoles.DIRECT_PARTNER || user.role === UserRoles.SUPER_ADMIN

export const USER_STORAGE_KEY = process.env.USER_STORAGE_KEY || 'mcUser'

export const APP_STORAGE_KEY = 'active_app'
